import {
  BackgroundProp,
  BorderProp,
  CornersProp,
  FontProp,
  GeneralProp,
  LayoutProp,
  MarginsProp,
  PaddingsProp,
  SizingProp,
} from "@/react/components/shared/BuilderUI/constants/PropCategories";

export const STYLE_CATEGORY_FIELDS: Record<string, string[]> = {
  typography: [
    "fontFamily",
    "fontSize",
    "fontWeight",
    "fontStyle",
    "lineHeight",
    "letterSpacing",
    "textAlign",
    "textDecoration",
    "textTransform",
    "color",
  ],
  layout: [
    "display",
    "flexDirection",
    "justifyContent",
    "alignItems",
    "alignContent",
    "flexWrap",
    "gap",
    "position",
    "top",
    "right",
    "bottom",
    "left",
    "zIndex",
  ],
  size: [
    "width",
    "height",
    "minWidth",
    "maxWidth",
    "minHeight",
    "maxHeight",
    "sizing",
  ],
  spacing: [
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
  ],
  background: [
    "backgroundColor",
    "backgroundImage",
    "backgroundSize",
    "backgroundPosition",
    "backgroundRepeat",
  ],
  borders: [
    "border",
    "borderWidth",
    "borderStyle",
    "borderColor",
    "borderRadius",
    "borderTop",
    "borderRight",
    "borderBottom",
    "borderLeft",
  ],
  effects: ["boxShadow", "transform", "filter"],
  general: ["objectFit", "objectPosition", "opacity"],
};

export const FIELD_TO_STYLE_CATEGORY_MAP: Record<string, string> =
  Object.entries(STYLE_CATEGORY_FIELDS).reduce(
    (acc, [category, fields]) => {
      fields.forEach(field => {
        acc[field] = category;
      });
      return acc;
    },
    {} as Record<string, string>,
  );

export const DEFAULT_EDITOR_V2_STYLE_CATEGORIES = [
  {
    key: "background",
    nameI18n: "builder_ui.editor.style_categories.background",
  },
  { key: "borders", nameI18n: "builder_ui.editor.style_categories.borders" },
  { key: "effects", nameI18n: "builder_ui.editor.style_categories.effects" },
  { key: "general", nameI18n: "builder_ui.editor.style_categories.general" },
  { key: "layout", nameI18n: "builder_ui.editor.style_categories.layout" },
  { key: "size", nameI18n: "builder_ui.editor.style_categories.size" },
  { key: "spacing", nameI18n: "builder_ui.editor.style_categories.spacing" },
  {
    key: "typography",
    nameI18n: "builder_ui.editor.style_categories.typography",
  },
];

export const META_CATEGORY_TO_STYLE_CATEGORY_MAP: Record<string, string> = {
  [GeneralProp.name]: "general",
  [CornersProp.name]: "borders",
  [SizingProp.name]: "size",
  [PaddingsProp.name]: "spacing",
  [MarginsProp.name]: "spacing",
  [FontProp.name]: "typography",
  [BackgroundProp.name]: "background",
  [BorderProp.name]: "borders",
  [LayoutProp.name]: "layout",
};
